import React, { useState } from "react";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { get } from "lodash";
import { fromJS } from "immutable";
import { useDispatch, useCurrentUser } from "APP_ROOT/hooks";
import { transformOQOutputValues } from "MODULES/shared/helpers";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";
import CreateQuoteForm from "./Form";
import SendQuoteForm from "./SendQuote";

export default function Create({ part, close }) {
  const { onSubmit, setSubmittedWith, createdQuote } = useCreateOnSubmit(
    part.id,
    close
  );

  const currentUser = useCurrentUser();
  const [selectedCompany, setSelectedCompany] = useState({});

  if (createdQuote) {
    return <SendQuoteForm close={close} quote={fromJS(createdQuote)} />;
  }
  return (
    <CreateQuoteForm
      close={close}
      onSubmit={onSubmit}
      setSubmittedWith={setSubmittedWith}
      currentUser={currentUser}
      selectedCompany={selectedCompany}
      setSelectedCompany={setSelectedCompany}
    />
  );
}

Create.propTypes = {
  close: PropTypes.func.isRequired,
  part: PropTypes.shape({
    id: PropTypes.number
  })
};

// Custom hooks
function useCreateOnSubmit(partId, close) {
  const dispatch = useDispatch();
  const [createdQuote, setCreatedQuote] = useState(null);
  const [submittedWith, setSubmittedWith] = useState(null);
  const onSubmit = async formData => {
    modifyFormDataForContactAdd(formData);

    formData.outgoing_quote_line_item = transformOQOutputValues(
      formData.outgoing_quote_line_item
    );

    const { data: quote } = await api.parts.outgoingQuotes.create(
      partId,
      formData
    );
    toastr.success("Success", `${quote.code} successfully created.`);

    if (submittedWith === "send") {
      setCreatedQuote(quote);
    } else {
      if (formData.send_quote) {
        modifyFormDataForSendQuote(formData, quote);
        await api.outgoingQuotes.send(quote.id, formData);
        toastr.success("Success", "Quote successfully sent.");
      }

      if (submittedWith === "save-and-go") {
        dispatch(push({ pathname: `/outgoing-quotes/${quote.uuid}` }));
      } else {
        window.scrollTo(0, 0);
        close();
      }
    }
  };

  return {
    onSubmit,
    setSubmittedWith,
    createdQuote
  };
}

function modifyFormDataForContactAdd(formData) {
  formData.contact_id =
    formData.contact_id === "Add" ? null : formData.contact_id;
}

function modifyFormDataForSendQuote(formData, quote) {
  formData.line_items = JSON.parse(
    JSON.stringify(quote.outgoing_quote_line_items)
  );
  formData.line_items.forEach(item => {
    if (formData.attach_traceability) {
      item.attach_traceability = true;
    }
    if (formData.attach_tag_copies) {
      item.attach_tag_copies = true;
    }
    if (formData.show_hazmat_warning) {
      item.show_hazmat_warning = true;
    }

    item.inventory_attachment_ids = get(
      formData,
      "outgoing_quote_line_item.inventory_attachment_ids"
    );
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/OutgoingQuotes/Create.jsx